/**
 * Light, dark, or whatever the machine says — the same cookie the site and the
 * panel read, so an operator's choice follows them across all three.
 */

export type Theme = "light" | "dark" | "system";

export const THEME_COOKIE = "ONDIT_THEME";

export function readTheme(): Theme {
	if (typeof document === "undefined") return "system";
	const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${THEME_COOKIE}=([^;]+)`));
	const raw = match ? decodeURIComponent(match[1]) : "";
	return raw === "light" || raw === "dark" ? raw : "system";
}

export function writeTheme(theme: Theme): void {
	const host = window.location.hostname;
	const domain = host.endsWith(".ondit.ai") || host === "ondit.ai" ? "; domain=.ondit.ai" : "";
	const secure = window.location.protocol === "https:" ? "; Secure" : "";
	// biome-ignore lint/suspicious/noDocumentCookie: parent-domain cookie, shared with the directory site
	document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=31536000; SameSite=Lax${domain}${secure}`;
	const root = document.documentElement;
	if (theme === "system") root.removeAttribute("data-theme");
	else root.setAttribute("data-theme", theme);
}
